import React from 'react';
import { Plane, ExternalLink } from 'lucide-react';
import { trackClick } from '../utils/analytics';

// 姉妹サービス「Seoul Match」への導線。
// 渡韓施術ユーザー向けのため、検索・施術まとめでは韓国系の文脈でのみ表示する。
const SEOUL_MATCH_BASE_URL = 'https://seoul-match-gilt.vercel.app/';

const KOREA_PATTERN = /韓国|渡韓|ソウル|江南|カンナム|狎鴎亭|明洞|カロスキル|新沙/;

export const isKoreaRelated = (text) => KOREA_PATTERN.test(String(text || ''));

export const buildSeoulMatchUrl = (placement) =>
  `${SEOUL_MATCH_BASE_URL}?utm_source=urakarte&utm_medium=web&utm_campaign=${encodeURIComponent(placement)}`;

const SeoulMatchCta = ({ placement = 'general', className = '' }) => (
  <section
    className={`rounded-2xl border border-sky-200 bg-gradient-to-br from-sky-50 to-white p-5 sm:p-6 ${className}`}
    aria-label="姉妹サービス Seoul Match"
  >
    <div className="flex items-start gap-3">
      <div className="p-2 rounded-xl bg-sky-100 text-sky-700 flex-shrink-0">
        <Plane className="w-5 h-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-[11px] font-semibold tracking-wider text-sky-500">姉妹サービス</p>
        <h2 className="mt-0.5 text-lg font-bold text-gray-900">
          渡韓ひとり整形、ダウンタイム中はずっと一人…
        </h2>
        <p className="text-sm text-gray-600 mt-1 leading-relaxed">
          そんなときに。韓国ひとり旅の食事・観光仲間や、ダウンタイム中の話し相手を、
          女性のための安心できる場で見つけられるサービスを作りました。
        </p>
        <a
          href={buildSeoulMatchUrl(placement)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackClick(`seoul_match_cta_${placement}`)}
          className="mt-4 inline-flex items-center justify-center gap-2 px-4 py-3 sm:py-2.5 rounded-lg bg-sky-600 text-white text-sm font-medium hover:bg-sky-700 touch-manipulation"
        >
          Seoul Matchを見てみる
          <ExternalLink className="w-4 h-4" />
        </a>
        <p className="mt-2 text-[11px] text-gray-400">外部サイト（Seoul Match）に移動します</p>
      </div>
    </div>
  </section>
);

export default SeoulMatchCta;
